import { useEffect, useState } from 'react';
import { captureException } from '@sentry/react';
import { requestToAccessToken } from '../services/autotask';
import { getUrlParam } from '../utils';

export default function useAutotaskAuth({ onSuccess, maxRetryCount = 3 } = {}) {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const appId = getUrlParam('vendorsuppliedid');

  useEffect(() => {
    requestToAccessToken({ maxRetryCount })
      .then(token => {
        onSuccess({ token, appId });
        setErrorMessage('');
        setIsLoading(false);
      })
      .catch(err => {
        const message = `Failed to authenticate through Autotask: ${
          err?.response?.data?.message || err?.message
        }`;

        captureException(new Error(message), {
          tags: {
            appId
          }
        });
        setIsLoading(false);
        setErrorMessage(message);
      });
  }, []);

  return { loading: isLoading, errorMessage };
}
